import React from 'react'
import AppBody from '../../components/AppBody'

const OrgUserDashboard = () => {
    return (
        <AppBody content={
            <h1>Org User Home Page </h1>  
        }/>            
    )
}

export default OrgUserDashboard
